import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import { useRef } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "services/redux/store";
import { setEmojiModalPostion } from "services/redux/postForm/postForm";
import {
    openMapModal,
    setEmojiIncidentId,
    setGifIncidentId
} from "services/redux/incidentForm/incidentForm";
import {
    openEmojiModal,
    openGifModal
} from "services/redux/commentForm/commentForm";

export type FormIncidentControlsProps = CustomComponentProps & {
    handleChangeImage: (images: FileList) => void;
    handleChangeVideo: (videos: FileList) => void;
    incidentId: number;
    handleRemoveIncident: () => void;
};

const FormIncidentControls = ({
    handleChangeImage,
    handleChangeVideo,
    incidentId,
    handleRemoveIncident,
    className,
    style
}: FormIncidentControlsProps) => {
    const imgInputRef = useRef(null);
    const videoInputRef = useRef(null);
    const dispatch = useDispatch<AppDispatch>();

    const emojiBtnRef = useRef(null);

    const openEmoji = () => {
        dispatch(setEmojiIncidentId(incidentId));
        dispatch(openEmojiModal());

        // @ts-ignore
        const rect = emojiBtnRef.current.getBoundingClientRect();
        console.log("rect", rect);
        const left = rect.left - 50;

        const parentElBottom = rect.bottom;
        // get height of who can see the post modal
        const elHeight = 400;
        // get window height
        const windowHeight = window.innerHeight;
        let top = 0;
        if (parentElBottom + elHeight - 10 >= windowHeight) {
            // make the elemnt above the btn
            top = parentElBottom - elHeight - 15;
        } else {
            // make the btn below the btn
            top = parentElBottom + 10;
        }

        dispatch(setEmojiModalPostion({ left, top }));
    };

    const openGif = () => {
        dispatch(setGifIncidentId(incidentId));
        dispatch(openGifModal());
    };

    return (
        <div
            className={`d-flex flex-j-start gap-10 post-form-input-group ${className}`}
            style={style}
        >
            {/* for image  */}
            <div className="post-form-input-container">
                <input
                    className="is-hidden"
                    type="file"
                    multiple
                    onChange={(e) =>
                        handleChangeImage(e.target.files as FileList)
                    }
                    accept="image/png, image/jpeg"
                    ref={imgInputRef}
                />
                <label
                    className="blue-white-text cursor-pointer"
                    onClick={() =>
                        (
                            imgInputRef.current as unknown as HTMLInputElement
                        ).click()
                    }
                >
                    <SVG svg="image" size={24} className="blue-svg" />
                </label>
            </div>
            {/* for video  */}
            <div className="post-form-input-container">
                <input
                    className="is-hidden"
                    type="file"
                    accept="video/mp4,video/x-m4v,video/*"
                    ref={videoInputRef}
                    onChange={(e) =>
                        handleChangeVideo(e.target.files as FileList)
                    }
                />
                <label
                    className="blue-white-text cursor-pointer"
                    onClick={() =>
                        (
                            videoInputRef.current as unknown as HTMLInputElement
                        ).click()
                    }
                >
                    <SVG svg="video" size={24} className="blue-svg" />
                </label>
            </div>
            {/* for gif  gifs-modal  */}
            <div className="post-form-input-container">
                <div
                    className="blue-white-text cursor-pointer"
                    onClick={openGif}
                >
                    <SVG svg="gif2" size={24} className="blue-svg" />
                </div>
            </div>
            {/* for map  */}

            <div
                className="post-form-input-container"
                onClick={() => dispatch(openMapModal(incidentId))}
            >
                <label>
                    <SVG svg="map-pointer" size={24} className="blue-svg" />
                </label>
            </div>

            {/* for emoji  */}
            <div className="post-form-input-container p-relative hide-sm">
                <div
                    className="blue-white-text cursor-pointer"
                    onClick={openEmoji}
                    ref={emojiBtnRef}
                >
                    <SVG svg="emoji" size={24} className="blue-svg" />
                </div>
            </div>

            {incidentId != 1 ? (
                <div
                    className="remove-subpost momeento-p red-text ml-auto cursor-pointer"
                    onClick={handleRemoveIncident}
                >
                    Remove
                </div>
            ) : (
                ""
            )}
        </div>
    );
};

export default FormIncidentControls;
